import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'No minimum wallet',
	'Same day delivery',
	'Pre Integrated GDS & APIs.',
	'Multiple Supplier Inventory',
	'Offline Flight Inventory Management',
	'Real time booking',
	'Real time cancellation',
	'Real time availability',
	'Live Fare rules',
	'Responsive design',
	'All device support',
	'Custom B2C Home Page',
	'Logo Design',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const SABRE = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/8.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					SABRE API INTEGRATION
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					SABRE API INTEGRATION
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30 }}>
					"Runs faster. Costs less. And never interupt."
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								Arya Aviation integrate Sabre GDS System which includes Flight
								Booking System, Hotel Booking System, Bus/Car Bookings and many
								more.
							</p>
							<br />
							<p>
								Sabre GDS system is suitable for B2C as well as B2B (Agents,
								Distributors and Super-Distributors) and provides fast seats
								confirmation. Sabre System also provides the best results for
								fares and commissions and is reliable for new customers too.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						The fastest way to grow your business with the leader in Travel
						Technology Check out our options and features included.
					</p>
				</Container>
			</div>

			<Container style={{ marginTop: 10 }}>
				<Grid container spacing={4} alignItems={'center'}>
					<Grid item xs={6}>
						<img src='https://aryaaviation.com/assets/images/ee.jpg' />
					</Grid>
					<Grid item xs={6}>
						<Container
							style={{ background: '#eaeaea', marginTop: 20, padding: 20 }}>
							<p style={{ fontSize: 14, fontWeight: 'bold' }}>
								Features of API Integrated by musafir:-
							</p>
						</Container>
						{step2.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</div>
	);
};

export default SABRE;
